export default "/images/20b7a6bafb67e25539144c0ce70a028a.avif";